import { render, staticRenderFns } from "./cfgManager2.vue?vue&type=template&id=0a533012&scoped=true"
import script from "./cfgManager2.vue?vue&type=script&lang=js"
export * from "./cfgManager2.vue?vue&type=script&lang=js"
import style0 from "./cfgManager2.vue?vue&type=style&index=0&id=0a533012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a533012",
  null
  
)

export default component.exports